import React from 'react';
import { Button } from '@skunexus/component-catalog';
import { OKTA_LOGIN_PATH } from '../constants';

function NikeLoginPage() {
    const handleClick = () => {
        window.location = OKTA_LOGIN_PATH;
    };
    return (
        <div>
            <h1 className="mb-3">
                <small>Welcome to The vAn</small>
            </h1>
            <Button onClick={handleClick}>Log in via Okta</Button>
        </div>
    );
}

export default NikeLoginPage;
